/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
/**
 * useOfflineSync — hook React sullo stato di rete + coda di sincronizzazione.
 */
import { useEffect, useState } from 'react';
import { syncEngine } from '@/lib/syncEngine';

export const useOfflineSync = () => {
  const [state, setState] = useState(syncEngine.state);
  useEffect(() => {
    syncEngine.start();
    return syncEngine.subscribe(setState);
  }, []);
  return { ...state, flush: () => syncEngine.flush(), refresh: () => syncEngine.refreshPending(), retryFailed: () => syncEngine.retryFailed() };
};

export default useOfflineSync;
